import Link from "next/link";
import styles from './breadcrumbs.module.scss'

function Breadcrumbs({ categoryName, articleTitle }) {
  const category = categoryName.split(' ').map((item) => {
    return item[0].toUpperCase() + item.slice(1, item.length)
  }).join(' ')

  return (
    <div className={styles.breadcrumbs}>
      <Link className={`${styles["blog-link"]} ${styles.crumb}`} href="/blog" >
        Blog
      </Link>
      <svg
        width="10" height="15"
        viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.0607 13.0607C13.6464 12.4749 13.6464 11.5251 13.0607 10.9393L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807612 1.97918 0.807612 2.92893 1.3934 3.51472L9.87868 12L1.3934 20.4853C0.807611 21.0711 0.807611 22.0208 1.3934 22.6066C1.97918 23.1924 2.92893 23.1924 3.51472 22.6066L13.0607 13.0607ZM11 13.5L12 13.5L12 10.5L11 10.5L11 13.5Z" fill="#8A8A8E" />
      </svg>
      <Link legacyBehavior href={`/blog/categories/${categoryName.toLowerCase()}`}>
        <span className={styles.crumb}>{category}</span></Link>
      <svg
        width="10" height="15" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.0607 13.0607C13.6464 12.4749 13.6464 11.5251 13.0607 10.9393L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807612 1.97918 0.807612 2.92893 1.3934 3.51472L9.87868 12L1.3934 20.4853C0.807611 21.0711 0.807611 22.0208 1.3934 22.6066C1.97918 23.1924 2.92893 23.1924 3.51472 22.6066L13.0607 13.0607ZM11 13.5L12 13.5L12 10.5L11 10.5L11 13.5Z" fill="#8A8A8E" />
      </svg>
      <span className={`${styles["crumb-title"]} ${styles.crumb}`}>{articleTitle}</span>
    </div>);
}

export default Breadcrumbs;